export default ['amount', 'billingDate'];
